//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type {
    UseQueryResult,
    QueryFunctionContext,
    UseQueryOptions,
    QueryClient,
    QueryKey,
    MutationKey,
    UseMutationOptions,
    UseMutationResult,
    QueryMeta,
    MutationMeta,
} from '@tanstack/react-query';
import {
    trimArrayEnd,
    isParameterObject,
    getBaseUrl,
    addMetaToOptions,
} from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './Client';
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SttQueryParameters = {
    voice_response: Types.FileParameter;
    language?: string | null | undefined;
};

export type SttMutationParameters = {
    voice_response: Types.FileParameter;
};

export type AssessmentGET2QueryParameters = {
    isCancelled?: boolean | null | undefined;
};

export type PageQueryParameters = {
    isCancelled?: boolean | null | undefined;
    page?: number | null | undefined;
    pageSize?: number | null | undefined;
};

export type AssessmentGET3QueryParameters = {
    assessmentId: number;
};

export type AssessmentDELETEQueryParameters = {
    assessmentId: number;
};

export type ContinueQueryParameters = {
    assessmentId: number;
};

export type PauseQueryParameters = {
    assessmentId: number;
};

export type TextQueryParameters = {
    assessmentId: number;
};

export type VoiceQueryParameters = {
    assessmentId: number;
    voice_response: Types.FileParameter;
};

export type VoiceMutationParameters = {
    voice_response: Types.FileParameter;
};

export type TopupGETQueryParameters = {
    id: number;
};

export type TransactionsQueryParameters = {
    transaction_type?: Types.Transaction_type | null | undefined;
};

export type ExampleQueryParameters = {
    id: number;
};

export type QuestionQueryParameters = {
    id: number;
};

export type FilesPOSTMutationParameters = {
    file: Types.FileParameter;
};

export type UserQueryParameters = {
    page?: number | null | undefined;
    pageSize?: number | null | undefined;
    source?: Types.Source | null | undefined;
    fileExt?: string | null | undefined;
};

export type DownloadQueryParameters = {
    fileId: string;
};

export type Download2QueryParameters = {
    fileId: string;
    userId: string;
};

export type InterviewGET2QueryParameters = {
    categoryType?: Types.CategoryType | null | undefined;
    isCancelled?: boolean | null | undefined;
};

export type Page2QueryParameters = {
    categoryType?: Types.CategoryType2 | null | undefined;
    isCancelled?: boolean | null | undefined;
    page?: number | null | undefined;
    pageSize?: number | null | undefined;
};

export type TypesGET2QueryParameters = {
    categoryType?: Types.CategoryType3 | null | undefined;
};

export type TypesDELETEQueryParameters = {
    interviewTypeId: string;
};

export type InterviewGET3QueryParameters = {
    interviewId: number;
};

export type InterviewDELETEQueryParameters = {
    interviewId: number;
};

export type Continue2QueryParameters = {
    interviewId: number;
};

export type Pause2QueryParameters = {
    interviewId: number;
};

export type Text2QueryParameters = {
    interviewId: number;
};

export type Voice2QueryParameters = {
    interviewId: number;
    voice_response: Types.FileParameter;
};

export type Voice2MutationParameters = {
    voice_response: Types.FileParameter;
};

export type ResumeMutationParameters = {
    file: Types.FileParameter;
};

export type Resume2MutationParameters = {
    file: Types.FileParameter;
};

export type FilesGETQueryParameters = {
    page?: number | null | undefined;
    pageSize?: number | null | undefined;
    source?: Types.Source2 | null | undefined;
    fileExt?: string | null | undefined;
};

export type FilesPUTMutationParameters = {
    file: Types.FileParameter;
};

export type StreamMutationParameters = {
    file: Types.FileParameter;
};

export type Download3QueryParameters = {
    fileId: string;
};

export type Download4QueryParameters = {
    fileId: string;
};

export type WsQueryParameters = {
    request: Types.RequestMessage;
};

export function assessmentGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/activity/assessment';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let assessmentGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetAssessmentActivitiesResponse,
        unknown,
        Types.GetAssessmentActivitiesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetAssessmentActivitiesResponse,
                unknown,
                Types.GetAssessmentActivitiesResponse
            >,
            'queryFn'
        >
    > = {};
export function getAssessmentGETDefaultOptions() {
    return assessmentGETDefaultOptions;
}
export function setAssessmentGETDefaultOptions(
    options: typeof assessmentGETDefaultOptions
) {
    assessmentGETDefaultOptions = options;
}

export function assessmentGETQueryKey(): QueryKey;
export function assessmentGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'assessmentGET']);
}
export function __assessmentGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.assessmentGET(axiosConfig);
}

/**
 * returns user activities on assessment
 * @return OK
 */
export function useAssessmentGETQuery<
    TSelectData = Types.GetAssessmentActivitiesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<
            Types.GetAssessmentActivitiesResponse,
            TError,
            TSelectData
        >,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useAssessmentGETQuery<
    TSelectData = Types.GetAssessmentActivitiesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.GetAssessmentActivitiesResponse,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetAssessmentActivitiesResponse, TError, TSelectData>(
        {
            queryFn: axiosConfig
                ? (context) => __assessmentGET(context, axiosConfig)
                : __assessmentGET,
            queryKey: assessmentGETQueryKey(),
            ...(assessmentGETDefaultOptions as unknown as Omit<
                UseQueryOptions<
                    Types.GetAssessmentActivitiesResponse,
                    TError,
                    TSelectData
                >,
                'queryKey'
            >),
            ...options,
        }
    );
}
/**
 * returns user activities on assessment
 * @return OK
 */
export function setAssessmentGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetAssessmentActivitiesResponse | undefined
    ) => Types.GetAssessmentActivitiesResponse
) {
    queryClient.setQueryData(assessmentGETQueryKey(), updater);
}

/**
 * returns user activities on assessment
 * @return OK
 */
export function setAssessmentGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetAssessmentActivitiesResponse | undefined
    ) => Types.GetAssessmentActivitiesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function courseGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/activity/course';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let courseGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetCourseActivitiesResponse,
        unknown,
        Types.GetCourseActivitiesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetCourseActivitiesResponse,
                unknown,
                Types.GetCourseActivitiesResponse
            >,
            'queryFn'
        >
    > = {};
export function getCourseGETDefaultOptions() {
    return courseGETDefaultOptions;
}
export function setCourseGETDefaultOptions(
    options: typeof courseGETDefaultOptions
) {
    courseGETDefaultOptions = options;
}

export function courseGETQueryKey(): QueryKey;
export function courseGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'courseGET']);
}
export function __courseGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.courseGET(axiosConfig);
}

/**
 * returns user activities on courses
 * @return OK
 */
export function useCourseGETQuery<
    TSelectData = Types.GetCourseActivitiesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetCourseActivitiesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useCourseGETQuery<
    TSelectData = Types.GetCourseActivitiesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.GetCourseActivitiesResponse,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetCourseActivitiesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __courseGET(context, axiosConfig)
            : __courseGET,
        queryKey: courseGETQueryKey(),
        ...(courseGETDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetCourseActivitiesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns user activities on courses
 * @return OK
 */
export function setCourseGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetCourseActivitiesResponse | undefined
    ) => Types.GetCourseActivitiesResponse
) {
    queryClient.setQueryData(courseGETQueryKey(), updater);
}

/**
 * returns user activities on courses
 * @return OK
 */
export function setCourseGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetCourseActivitiesResponse | undefined
    ) => Types.GetCourseActivitiesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function graphUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/activity/graph';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let graphDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetActivityGraphResponse,
        unknown,
        Types.GetActivityGraphResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetActivityGraphResponse,
                unknown,
                Types.GetActivityGraphResponse
            >,
            'queryFn'
        >
    > = {};
export function getGraphDefaultOptions() {
    return graphDefaultOptions;
}
export function setGraphDefaultOptions(options: typeof graphDefaultOptions) {
    graphDefaultOptions = options;
}

export function graphQueryKey(): QueryKey;
export function graphQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'graph']);
}
export function __graph(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.graph(axiosConfig);
}

/**
 * returns graph of user activities
 * @return OK
 */
export function useGraphQuery<
    TSelectData = Types.GetActivityGraphResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetActivityGraphResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useGraphQuery<
    TSelectData = Types.GetActivityGraphResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetActivityGraphResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetActivityGraphResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __graph(context, axiosConfig)
            : __graph,
        queryKey: graphQueryKey(),
        ...(graphDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetActivityGraphResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns graph of user activities
 * @return OK
 */
export function setGraphData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetActivityGraphResponse | undefined
    ) => Types.GetActivityGraphResponse
) {
    queryClient.setQueryData(graphQueryKey(), updater);
}

/**
 * returns graph of user activities
 * @return OK
 */
export function setGraphDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetActivityGraphResponse | undefined
    ) => Types.GetActivityGraphResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function interviewGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/activity/interview';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let interviewGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetInterviewActivitiesResponse,
        unknown,
        Types.GetInterviewActivitiesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetInterviewActivitiesResponse,
                unknown,
                Types.GetInterviewActivitiesResponse
            >,
            'queryFn'
        >
    > = {};
export function getInterviewGETDefaultOptions() {
    return interviewGETDefaultOptions;
}
export function setInterviewGETDefaultOptions(
    options: typeof interviewGETDefaultOptions
) {
    interviewGETDefaultOptions = options;
}

export function interviewGETQueryKey(): QueryKey;
export function interviewGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'interviewGET']);
}
export function __interviewGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.interviewGET(axiosConfig);
}

/**
 * returns user activities on interviews
 * @return OK
 */
export function useInterviewGETQuery<
    TSelectData = Types.GetInterviewActivitiesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<
            Types.GetInterviewActivitiesResponse,
            TError,
            TSelectData
        >,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useInterviewGETQuery<
    TSelectData = Types.GetInterviewActivitiesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.GetInterviewActivitiesResponse,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetInterviewActivitiesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __interviewGET(context, axiosConfig)
            : __interviewGET,
        queryKey: interviewGETQueryKey(),
        ...(interviewGETDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetInterviewActivitiesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns user activities on interviews
 * @return OK
 */
export function setInterviewGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetInterviewActivitiesResponse | undefined
    ) => Types.GetInterviewActivitiesResponse
) {
    queryClient.setQueryData(interviewGETQueryKey(), updater);
}

/**
 * returns user activities on interviews
 * @return OK
 */
export function setInterviewGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetInterviewActivitiesResponse | undefined
    ) => Types.GetInterviewActivitiesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function allUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/activity/interview/all';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let allDefaultOptions: Omit<
    UseQueryOptions<
        { [key: string]: Types.GetInterviewActivitiesResponse },
        unknown,
        { [key: string]: Types.GetInterviewActivitiesResponse }
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                { [key: string]: Types.GetInterviewActivitiesResponse },
                unknown,
                { [key: string]: Types.GetInterviewActivitiesResponse }
            >,
            'queryFn'
        >
    > = {};
export function getAllDefaultOptions() {
    return allDefaultOptions;
}
export function setAllDefaultOptions(options: typeof allDefaultOptions) {
    allDefaultOptions = options;
}

export function allQueryKey(): QueryKey;
export function allQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'all']);
}
export function __all(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.all(axiosConfig);
}

/**
 * returns user activities on interviews grouped by interview category type
 * @return OK
 */
export function useAllQuery<
    TSelectData = { [key: string]: Types.GetInterviewActivitiesResponse },
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<
            { [key: string]: Types.GetInterviewActivitiesResponse },
            TError,
            TSelectData
        >,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useAllQuery<
    TSelectData = { [key: string]: Types.GetInterviewActivitiesResponse },
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              { [key: string]: Types.GetInterviewActivitiesResponse },
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<
        { [key: string]: Types.GetInterviewActivitiesResponse },
        TError,
        TSelectData
    >({
        queryFn: axiosConfig ? (context) => __all(context, axiosConfig) : __all,
        queryKey: allQueryKey(),
        ...(allDefaultOptions as unknown as Omit<
            UseQueryOptions<
                { [key: string]: Types.GetInterviewActivitiesResponse },
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns user activities on interviews grouped by interview category type
 * @return OK
 */
export function setAllData(
    queryClient: QueryClient,
    updater: (
        data:
            | { [key: string]: Types.GetInterviewActivitiesResponse }
            | undefined
    ) => { [key: string]: Types.GetInterviewActivitiesResponse }
) {
    queryClient.setQueryData(allQueryKey(), updater);
}

/**
 * returns user activities on interviews grouped by interview category type
 * @return OK
 */
export function setAllDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data:
            | { [key: string]: Types.GetInterviewActivitiesResponse }
            | undefined
    ) => { [key: string]: Types.GetInterviewActivitiesResponse }
) {
    queryClient.setQueryData(queryKey, updater);
}

export function suggestionUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/agent/suggestion';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let suggestionDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetSuggestionResponse,
        unknown,
        Types.GetSuggestionResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetSuggestionResponse,
                unknown,
                Types.GetSuggestionResponse
            >,
            'queryFn'
        >
    > = {};
export function getSuggestionDefaultOptions() {
    return suggestionDefaultOptions;
}
export function setSuggestionDefaultOptions(
    options: typeof suggestionDefaultOptions
) {
    suggestionDefaultOptions = options;
}

export function suggestionQueryKey(): QueryKey;
export function suggestionQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'suggestion']);
}
export function __suggestion(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.suggestion(axiosConfig);
}

/**
 * returns agent's suggestion
 * @return OK
 */
export function useSuggestionQuery<
    TSelectData = Types.GetSuggestionResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetSuggestionResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useSuggestionQuery<
    TSelectData = Types.GetSuggestionResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetSuggestionResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetSuggestionResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __suggestion(context, axiosConfig)
            : __suggestion,
        queryKey: suggestionQueryKey(),
        ...(suggestionDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetSuggestionResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns agent's suggestion
 * @return OK
 */
export function setSuggestionData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetSuggestionResponse | undefined
    ) => Types.GetSuggestionResponse
) {
    queryClient.setQueryData(suggestionQueryKey(), updater);
}

/**
 * returns agent's suggestion
 * @return OK
 */
export function setSuggestionDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetSuggestionResponse | undefined
    ) => Types.GetSuggestionResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function qUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/ai/q';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function qMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'q']);
}

/**
 * AskQuestion
 * @param question Question
 * @return OK
 */
export function useQMutation<TContext>(
    options?: Omit<
        UseMutationOptions<string, unknown, Types.QuestionRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<string, unknown, Types.QuestionRequest, TContext> {
    const key = qMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (question: Types.QuestionRequest) => Client.q(question),
        mutationKey: key,
    });
}

export function postUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/ai/social/post';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function postMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'post']);
}

/**
 * GenerateSocialPost
 * @param description Description
 * @return OK
 */
export function usePostMutation<TContext>(
    options?: Omit<
        UseMutationOptions<string, unknown, Types.SocialPostRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<string, unknown, Types.SocialPostRequest, TContext> {
    const key = postMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (description: Types.SocialPostRequest) =>
            Client.post(description),
        mutationKey: key,
    });
}

export function sttUrl(language?: string | null | undefined): string {
    let url_ = getBaseUrl() + '/api/v1/ai/stt?';
    if (language !== undefined && language !== null)
        url_ += 'language=' + encodeURIComponent('' + language) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function sttMutationKey(
    language?: string | null | undefined
): MutationKey {
    return trimArrayEnd(['Client', 'stt', language as any]);
}

/**
 * Speech to text
 * @param voice_response The voice file
 * @param language (optional) speech to text language
 * @return OK
 */
export function useSttMutation<TContext>(
    language?: string | null | undefined,
    options?: Omit<
        UseMutationOptions<string, unknown, SttMutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<string, unknown, SttMutationParameters, TContext> {
    const key = sttMutationKey(language);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (sttMutationParameters: SttMutationParameters) =>
            Client.stt(sttMutationParameters.voice_response, language),
        mutationKey: key,
    });
}

type Stt__MutationParameters = SttQueryParameters & {
    sttMutationParameters: SttMutationParameters;
};

/**
 * Speech to text
 * @param voice_response The voice file
 * @param language (optional) speech to text language
 * @return OK
 */
export function useSttMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<string, unknown, Stt__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: SttQueryParameters }
): UseMutationResult<string, unknown, Stt__MutationParameters, TContext> {
    const key = sttMutationKey(options?.parameters?.language!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Stt__MutationParameters) =>
            Client.stt(data.voice_response, data.language),
        mutationKey: key,
    });
}

export function ttsUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/ai/tts';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function ttsMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'tts']);
}

/**
 * TTS
 * @param request Request
 * @return OK
 */
export function useTtsMutation<TContext>(
    options?: Omit<
        UseMutationOptions<string, unknown, Types.TTSRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<string, unknown, Types.TTSRequest, TContext> {
    const key = ttsMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.TTSRequest) => Client.tts(request),
        mutationKey: key,
    });
}

export function assessmentGET2Url(
    isCancelled?: boolean | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/assessment?';
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += 'isCancelled=' + encodeURIComponent('' + isCancelled) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let assessmentGET2DefaultOptions: Omit<
    UseQueryOptions<
        Types.ListAssessmentsResponse,
        unknown,
        Types.ListAssessmentsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListAssessmentsResponse,
                unknown,
                Types.ListAssessmentsResponse
            >,
            'queryFn'
        >
    > = {};
export function getAssessmentGET2DefaultOptions() {
    return assessmentGET2DefaultOptions;
}
export function setAssessmentGET2DefaultOptions(
    options: typeof assessmentGET2DefaultOptions
) {
    assessmentGET2DefaultOptions = options;
}

export function assessmentGET2QueryKey(
    isCancelled?: boolean | null | undefined
): QueryKey;
export function assessmentGET2QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { isCancelled } = params[0] as AssessmentGET2QueryParameters;

        return trimArrayEnd(['Client', 'assessmentGET2', isCancelled as any]);
    } else {
        return trimArrayEnd(['Client', 'assessmentGET2', ...params]);
    }
}
export function __assessmentGET2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.assessmentGET2(
        context.queryKey[2] as boolean | null | undefined,
        axiosConfig
    );
}

export function useAssessmentGET2Query<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(
    dto: AssessmentGET2QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * ListAssessments
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function useAssessmentGET2Query<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(
    isCancelled?: boolean | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useAssessmentGET2Query<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let isCancelled: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ isCancelled } = params[0] as AssessmentGET2QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [isCancelled, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListAssessmentsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __assessmentGET2(context, axiosConfig)
            : __assessmentGET2,
        queryKey: assessmentGET2QueryKey(isCancelled),
        ...(assessmentGET2DefaultOptions as unknown as Omit<
            UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListAssessments
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function setAssessmentGET2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.ListAssessmentsResponse | undefined
    ) => Types.ListAssessmentsResponse,
    isCancelled?: boolean | null | undefined
) {
    queryClient.setQueryData(assessmentGET2QueryKey(isCancelled), updater);
}

/**
 * ListAssessments
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function setAssessmentGET2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListAssessmentsResponse | undefined
    ) => Types.ListAssessmentsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function assessmentPOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/assessment';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function assessmentPOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'assessmentPOST']);
}

/**
 * CreateAssessment
 * @param request Request
 * @return OK
 */
export function useAssessmentPOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.CreateAssessmentResponse,
            unknown,
            Types.CreateAssessmentRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.CreateAssessmentResponse,
    unknown,
    Types.CreateAssessmentRequest,
    TContext
> {
    const key = assessmentPOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.CreateAssessmentRequest) =>
            Client.assessmentPOST(request),
        mutationKey: key,
    });
}

export function pageUrl(
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/page?';
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += 'isCancelled=' + encodeURIComponent('' + isCancelled) + '&';
    if (page !== undefined && page !== null)
        url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize !== undefined && pageSize !== null)
        url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let pageDefaultOptions: Omit<
    UseQueryOptions<
        Types.ListAssessmentsResponse,
        unknown,
        Types.ListAssessmentsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListAssessmentsResponse,
                unknown,
                Types.ListAssessmentsResponse
            >,
            'queryFn'
        >
    > = {};
export function getPageDefaultOptions() {
    return pageDefaultOptions;
}
export function setPageDefaultOptions(options: typeof pageDefaultOptions) {
    pageDefaultOptions = options;
}

export function pageQueryKey(dto: PageQueryParameters): QueryKey;
export function pageQueryKey(
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
): QueryKey;
export function pageQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { isCancelled, page, pageSize } =
            params[0] as PageQueryParameters;

        return trimArrayEnd([
            'Client',
            'page',
            isCancelled as any,
            page as any,
            pageSize as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'page', ...params]);
    }
}
export function __page(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.page(
        context.queryKey[2] as boolean | null | undefined,
        context.queryKey[3] as number | null | undefined,
        context.queryKey[4] as number | null | undefined,
        axiosConfig
    );
}

export function usePageQuery<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(
    dto: PageQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * ListAssessmentsPageable
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function usePageQuery<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function usePageQuery<
    TSelectData = Types.ListAssessmentsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let isCancelled: any = undefined;
    let page: any = undefined;
    let pageSize: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ isCancelled, page, pageSize } =
                params[0] as PageQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [isCancelled, page, pageSize, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListAssessmentsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __page(context, axiosConfig)
            : __page,
        queryKey: pageQueryKey(isCancelled, page, pageSize),
        ...(pageDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.ListAssessmentsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListAssessmentsPageable
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function setPageData(
    queryClient: QueryClient,
    updater: (
        data: Types.ListAssessmentsResponse | undefined
    ) => Types.ListAssessmentsResponse,
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
) {
    queryClient.setQueryData(
        pageQueryKey(isCancelled, page, pageSize),
        updater
    );
}

/**
 * ListAssessmentsPageable
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function setPageDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListAssessmentsResponse | undefined
    ) => Types.ListAssessmentsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function typesGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/types';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let typesGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.ListAssessmentTypesResponse,
        unknown,
        Types.ListAssessmentTypesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListAssessmentTypesResponse,
                unknown,
                Types.ListAssessmentTypesResponse
            >,
            'queryFn'
        >
    > = {};
export function getTypesGETDefaultOptions() {
    return typesGETDefaultOptions;
}
export function setTypesGETDefaultOptions(
    options: typeof typesGETDefaultOptions
) {
    typesGETDefaultOptions = options;
}

export function typesGETQueryKey(): QueryKey;
export function typesGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'typesGET']);
}
export function __typesGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.typesGET(axiosConfig);
}

/**
 * ListAssessmentTypes
 * @return OK
 */
export function useTypesGETQuery<
    TSelectData = Types.ListAssessmentTypesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.ListAssessmentTypesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useTypesGETQuery<
    TSelectData = Types.ListAssessmentTypesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.ListAssessmentTypesResponse,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListAssessmentTypesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __typesGET(context, axiosConfig)
            : __typesGET,
        queryKey: typesGETQueryKey(),
        ...(typesGETDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListAssessmentTypesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListAssessmentTypes
 * @return OK
 */
export function setTypesGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.ListAssessmentTypesResponse | undefined
    ) => Types.ListAssessmentTypesResponse
) {
    queryClient.setQueryData(typesGETQueryKey(), updater);
}

/**
 * ListAssessmentTypes
 * @return OK
 */
export function setTypesGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListAssessmentTypesResponse | undefined
    ) => Types.ListAssessmentTypesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function assessmentGET3Url(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let assessmentGET3DefaultOptions: Omit<
    UseQueryOptions<
        Types.GetAssessmentsResponse,
        unknown,
        Types.GetAssessmentsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetAssessmentsResponse,
                unknown,
                Types.GetAssessmentsResponse
            >,
            'queryFn'
        >
    > = {};
export function getAssessmentGET3DefaultOptions() {
    return assessmentGET3DefaultOptions;
}
export function setAssessmentGET3DefaultOptions(
    options: typeof assessmentGET3DefaultOptions
) {
    assessmentGET3DefaultOptions = options;
}

export function assessmentGET3QueryKey(assessmentId: number): QueryKey;
export function assessmentGET3QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { assessmentId } = params[0] as AssessmentGET3QueryParameters;

        return trimArrayEnd(['Client', 'assessmentGET3', assessmentId as any]);
    } else {
        return trimArrayEnd(['Client', 'assessmentGET3', ...params]);
    }
}
export function __assessmentGET3(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.assessmentGET3(context.queryKey[2] as number, axiosConfig);
}

export function useAssessmentGET3Query<
    TSelectData = Types.GetAssessmentsResponse,
    TError = unknown
>(
    dto: AssessmentGET3QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.GetAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * GetAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function useAssessmentGET3Query<
    TSelectData = Types.GetAssessmentsResponse,
    TError = unknown
>(
    assessmentId: number,
    options?: Omit<
        UseQueryOptions<Types.GetAssessmentsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useAssessmentGET3Query<
    TSelectData = Types.GetAssessmentsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetAssessmentsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let assessmentId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ assessmentId } = params[0] as AssessmentGET3QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [assessmentId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetAssessmentsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __assessmentGET3(context, axiosConfig)
            : __assessmentGET3,
        queryKey: assessmentGET3QueryKey(assessmentId),
        ...(assessmentGET3DefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetAssessmentsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * GetAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function setAssessmentGET3Data(
    queryClient: QueryClient,
    updater: (
        data: Types.GetAssessmentsResponse | undefined
    ) => Types.GetAssessmentsResponse,
    assessmentId: number
) {
    queryClient.setQueryData(assessmentGET3QueryKey(assessmentId), updater);
}

/**
 * GetAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function setAssessmentGET3DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetAssessmentsResponse | undefined
    ) => Types.GetAssessmentsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function assessmentDELETEUrl(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function assessmentDELETEMutationKey(assessmentId: number): MutationKey {
    return trimArrayEnd(['Client', 'assessmentDELETE', assessmentId as any]);
}

/**
 * CancelAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function useAssessmentDELETEMutation<TContext>(
    assessmentId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = assessmentDELETEMutationKey(assessmentId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.assessmentDELETE(assessmentId),
        mutationKey: key,
    });
}

type AssessmentDELETE__MutationParameters = AssessmentDELETEQueryParameters;

/**
 * CancelAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function useAssessmentDELETEMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            AssessmentDELETE__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: AssessmentDELETEQueryParameters }
): UseMutationResult<
    void,
    unknown,
    AssessmentDELETE__MutationParameters,
    TContext
> {
    const key = assessmentDELETEMutationKey(options?.parameters?.assessmentId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: AssessmentDELETE__MutationParameters) =>
            Client.assessmentDELETE(
                data.assessmentId ?? options?.parameters?.assessmentId!
            ),
        mutationKey: key,
    });
}

export function continueUrl(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}/continue';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function continueMutationKey(assessmentId: number): MutationKey {
    return trimArrayEnd(['Client', 'continue', assessmentId as any]);
}

/**
 * ContinueAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function useContinueMutation<TContext>(
    assessmentId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = continueMutationKey(assessmentId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.continue_(assessmentId),
        mutationKey: key,
    });
}

type Continue__MutationParameters = ContinueQueryParameters;

/**
 * ContinueAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function useContinueMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Continue__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: ContinueQueryParameters }
): UseMutationResult<void, unknown, Continue__MutationParameters, TContext> {
    const key = continueMutationKey(options?.parameters?.assessmentId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Continue__MutationParameters) =>
            Client.continue_(
                data.assessmentId ?? options?.parameters?.assessmentId!
            ),
        mutationKey: key,
    });
}

export function pauseUrl(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}/pause';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function pauseMutationKey(assessmentId: number): MutationKey {
    return trimArrayEnd(['Client', 'pause', assessmentId as any]);
}

/**
 * PauseAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function usePauseMutation<TContext>(
    assessmentId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = pauseMutationKey(assessmentId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.pause(assessmentId),
        mutationKey: key,
    });
}

type Pause__MutationParameters = PauseQueryParameters;

/**
 * PauseAssessment
 * @param assessmentId Assessment ID
 * @return OK
 */
export function usePauseMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Pause__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: PauseQueryParameters }
): UseMutationResult<void, unknown, Pause__MutationParameters, TContext> {
    const key = pauseMutationKey(options?.parameters?.assessmentId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Pause__MutationParameters) =>
            Client.pause(
                data.assessmentId ?? options?.parameters?.assessmentId!
            ),
        mutationKey: key,
    });
}

export function textUrl(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}/respond/text';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function textMutationKey(assessmentId: number): MutationKey {
    return trimArrayEnd(['Client', 'text', assessmentId as any]);
}

/**
 * RespondToAssessmentText
 * @param assessmentId Assessment ID
 * @param request Request
 * @return OK
 */
export function useTextMutation<TContext>(
    assessmentId: number,
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Types.RespondToAssessmentTextRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    void,
    unknown,
    Types.RespondToAssessmentTextRequest,
    TContext
> {
    const key = textMutationKey(assessmentId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.RespondToAssessmentTextRequest) =>
            Client.text(assessmentId, request),
        mutationKey: key,
    });
}

type Text__MutationParameters = TextQueryParameters & {
    request: Types.RespondToAssessmentTextRequest;
};

/**
 * RespondToAssessmentText
 * @param assessmentId Assessment ID
 * @param request Request
 * @return OK
 */
export function useTextMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Text__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: TextQueryParameters }
): UseMutationResult<void, unknown, Text__MutationParameters, TContext> {
    const key = textMutationKey(options?.parameters?.assessmentId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Text__MutationParameters) =>
            Client.text(
                data.assessmentId ?? options?.parameters?.assessmentId!,
                data.request
            ),
        mutationKey: key,
    });
}

export function voiceUrl(assessmentId: number): string {
    let url_ = getBaseUrl() + '/api/v1/assessment/{assessmentId}/respond/voice';
    if (assessmentId === undefined || assessmentId === null)
        throw new Error("The parameter 'assessmentId' must be defined.");
    url_ = url_.replace(
        '{assessmentId}',
        encodeURIComponent('' + assessmentId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function voiceMutationKey(assessmentId: number): MutationKey {
    return trimArrayEnd(['Client', 'voice', assessmentId as any]);
}

/**
 * RespondToAssessmentVoice
 * @param assessmentId Assessment ID
 * @param voice_response The response voice file
 * @return OK
 */
export function useVoiceMutation<TContext>(
    assessmentId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, VoiceMutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, VoiceMutationParameters, TContext> {
    const key = voiceMutationKey(assessmentId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (voiceMutationParameters: VoiceMutationParameters) =>
            Client.voice(assessmentId, voiceMutationParameters.voice_response),
        mutationKey: key,
    });
}

type Voice__MutationParameters = VoiceQueryParameters & {
    voiceMutationParameters: VoiceMutationParameters;
};

/**
 * RespondToAssessmentVoice
 * @param assessmentId Assessment ID
 * @param voice_response The response voice file
 * @return OK
 */
export function useVoiceMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Voice__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: VoiceQueryParameters }
): UseMutationResult<void, unknown, Voice__MutationParameters, TContext> {
    const key = voiceMutationKey(options?.parameters?.assessmentId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Voice__MutationParameters) =>
            Client.voice(data.assessmentId, data.voice_response),
        mutationKey: key,
    });
}

export function balanceUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/billing/balance';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let balanceDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetBalanceResponse,
        unknown,
        Types.GetBalanceResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetBalanceResponse,
                unknown,
                Types.GetBalanceResponse
            >,
            'queryFn'
        >
    > = {};
export function getBalanceDefaultOptions() {
    return balanceDefaultOptions;
}
export function setBalanceDefaultOptions(
    options: typeof balanceDefaultOptions
) {
    balanceDefaultOptions = options;
}

export function balanceQueryKey(): QueryKey;
export function balanceQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'balance']);
}
export function __balance(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.balance(axiosConfig);
}

/**
 * returns user balance
 * @return OK
 */
export function useBalanceQuery<
    TSelectData = Types.GetBalanceResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetBalanceResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useBalanceQuery<
    TSelectData = Types.GetBalanceResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetBalanceResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetBalanceResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __balance(context, axiosConfig)
            : __balance,
        queryKey: balanceQueryKey(),
        ...(balanceDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetBalanceResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns user balance
 * @return OK
 */
export function setBalanceData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetBalanceResponse | undefined
    ) => Types.GetBalanceResponse
) {
    queryClient.setQueryData(balanceQueryKey(), updater);
}

/**
 * returns user balance
 * @return OK
 */
export function setBalanceDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetBalanceResponse | undefined
    ) => Types.GetBalanceResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function settingsGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/billing/settings';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let settingsGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetBillingSettingsResponse,
        unknown,
        Types.GetBillingSettingsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetBillingSettingsResponse,
                unknown,
                Types.GetBillingSettingsResponse
            >,
            'queryFn'
        >
    > = {};
export function getSettingsGETDefaultOptions() {
    return settingsGETDefaultOptions;
}
export function setSettingsGETDefaultOptions(
    options: typeof settingsGETDefaultOptions
) {
    settingsGETDefaultOptions = options;
}

export function settingsGETQueryKey(): QueryKey;
export function settingsGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'settingsGET']);
}
export function __settingsGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.settingsGET(axiosConfig);
}

/**
 * get billing settings
 * @return OK
 */
export function useSettingsGETQuery<
    TSelectData = Types.GetBillingSettingsResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetBillingSettingsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useSettingsGETQuery<
    TSelectData = Types.GetBillingSettingsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetBillingSettingsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetBillingSettingsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __settingsGET(context, axiosConfig)
            : __settingsGET,
        queryKey: settingsGETQueryKey(),
        ...(settingsGETDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetBillingSettingsResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * get billing settings
 * @return OK
 */
export function setSettingsGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetBillingSettingsResponse | undefined
    ) => Types.GetBillingSettingsResponse
) {
    queryClient.setQueryData(settingsGETQueryKey(), updater);
}

/**
 * get billing settings
 * @return OK
 */
export function setSettingsGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetBillingSettingsResponse | undefined
    ) => Types.GetBillingSettingsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function settingsPOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/billing/settings';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function settingsPOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'settingsPOST']);
}

/**
 * update billing settings
 * @param request Request
 * @return OK
 */
export function useSettingsPOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Types.UpdateBillingSettingsRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    void,
    unknown,
    Types.UpdateBillingSettingsRequest,
    TContext
> {
    const key = settingsPOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.UpdateBillingSettingsRequest) =>
            Client.settingsPOST(request),
        mutationKey: key,
    });
}

export function summaryUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/billing/spend/summary';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let summaryDefaultOptions: Omit<
    UseQueryOptions<
        Types.ListTransactionsResponse,
        unknown,
        Types.ListTransactionsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListTransactionsResponse,
                unknown,
                Types.ListTransactionsResponse
            >,
            'queryFn'
        >
    > = {};
export function getSummaryDefaultOptions() {
    return summaryDefaultOptions;
}
export function setSummaryDefaultOptions(
    options: typeof summaryDefaultOptions
) {
    summaryDefaultOptions = options;
}

export function summaryQueryKey(): QueryKey;
export function summaryQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'summary']);
}
export function __summary(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.summary(axiosConfig);
}

/**
 * returns spend summary
 * @return OK
 */
export function useSummaryQuery<
    TSelectData = Types.ListTransactionsResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.ListTransactionsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useSummaryQuery<
    TSelectData = Types.ListTransactionsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListTransactionsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListTransactionsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __summary(context, axiosConfig)
            : __summary,
        queryKey: summaryQueryKey(),
        ...(summaryDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListTransactionsResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * returns spend summary
 * @return OK
 */
export function setSummaryData(
    queryClient: QueryClient,
    updater: (
        data: Types.ListTransactionsResponse | undefined
    ) => Types.ListTransactionsResponse
) {
    queryClient.setQueryData(summaryQueryKey(), updater);
}

/**
 * returns spend summary
 * @return OK
 */
export function setSummaryDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListTransactionsResponse | undefined
    ) => Types.ListTransactionsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function topupPOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/billing/topup';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function topupPOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'topupPOST']);
}

/**
 * top-up
 * @param request Request
 * @return OK
 */
export function useTopupPOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.TopUpResponse,
            unknown,
            Types.TopUpRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.TopUpResponse,
    unknown,
    Types.TopUpRequest,
    TContext
> {
    const key = topupPOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.TopUpRequest) => Client.topupPOST(request),
        mutationKey: key,
    });
}

export function topupGETUrl(id: number): string {
    let url_ = getBaseUrl() + '/api/v1/billing/topup/{id}';
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let topupGETDefaultOptions: Omit<
    UseQueryOptions<Types.TopUp, unknown, Types.TopUp>,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<UseQueryOptions<Types.TopUp, unknown, Types.TopUp>, 'queryFn'>
    > = {};
export function getTopupGETDefaultOptions() {
    return topupGETDefaultOptions;
}
export function setTopupGETDefaultOptions(
    options: typeof topupGETDefaultOptions
) {
    topupGETDefaultOptions = options;
}

export function topupGETQueryKey(id: number): QueryKey;
export function topupGETQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { id } = params[0] as TopupGETQueryParameters;

        return trimArrayEnd(['Client', 'topupGET', id as any]);
    } else {
        return trimArrayEnd(['Client', 'topupGET', ...params]);
    }
}
export function __topupGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.topupGET(context.queryKey[2] as number, axiosConfig);
}

export function useTopupGETQuery<TSelectData = Types.TopUp, TError = unknown>(
    dto: TopupGETQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.TopUp, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * get top-up
 * @param id TopUpID
 * @return OK
 */
export function useTopupGETQuery<TSelectData = Types.TopUp, TError = unknown>(
    id: number,
    options?: Omit<
        UseQueryOptions<Types.TopUp, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useTopupGETQuery<TSelectData = Types.TopUp, TError = unknown>(
    ...params: any[]
): UseQueryResult<TSelectData, TError> {
    let options: UseQueryOptions<Types.TopUp, TError, TSelectData> | undefined =
        undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let id: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ id } = params[0] as TopupGETQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [id, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.TopUp, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __topupGET(context, axiosConfig)
            : __topupGET,
        queryKey: topupGETQueryKey(id),
        ...(topupGETDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.TopUp, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * get top-up
 * @param id TopUpID
 * @return OK
 */
export function setTopupGETData(
    queryClient: QueryClient,
    updater: (data: Types.TopUp | undefined) => Types.TopUp,
    id: number
) {
    queryClient.setQueryData(topupGETQueryKey(id), updater);
}

/**
 * get top-up
 * @param id TopUpID
 * @return OK
 */
export function setTopupGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: Types.TopUp | undefined) => Types.TopUp
) {
    queryClient.setQueryData(queryKey, updater);
}

export function transactionsUrl(
    transaction_type?: Types.Transaction_type | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/billing/transactions?';
    if (transaction_type !== undefined && transaction_type !== null)
        url_ +=
            'transaction_type=' +
            encodeURIComponent('' + transaction_type) +
            '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let transactionsDefaultOptions: Omit<
    UseQueryOptions<
        Types.ListTransactionsResponse,
        unknown,
        Types.ListTransactionsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListTransactionsResponse,
                unknown,
                Types.ListTransactionsResponse
            >,
            'queryFn'
        >
    > = {};
export function getTransactionsDefaultOptions() {
    return transactionsDefaultOptions;
}
export function setTransactionsDefaultOptions(
    options: typeof transactionsDefaultOptions
) {
    transactionsDefaultOptions = options;
}

export function transactionsQueryKey(
    transaction_type?: Types.Transaction_type | null | undefined
): QueryKey;
export function transactionsQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { transaction_type } = params[0] as TransactionsQueryParameters;

        return trimArrayEnd([
            'Client',
            'transactions',
            transaction_type as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'transactions', ...params]);
    }
}
export function __transactions(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.transactions(
        context.queryKey[2] as Types.Transaction_type | null | undefined,
        axiosConfig
    );
}

export function useTransactionsQuery<
    TSelectData = Types.ListTransactionsResponse,
    TError = unknown
>(
    dto: TransactionsQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListTransactionsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * lists transactions
 * @param transaction_type (optional) Transaction type
 * @return OK
 */
export function useTransactionsQuery<
    TSelectData = Types.ListTransactionsResponse,
    TError = unknown
>(
    transaction_type?: Types.Transaction_type | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListTransactionsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useTransactionsQuery<
    TSelectData = Types.ListTransactionsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListTransactionsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let transaction_type: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ transaction_type } = params[0] as TransactionsQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [transaction_type, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListTransactionsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __transactions(context, axiosConfig)
            : __transactions,
        queryKey: transactionsQueryKey(transaction_type),
        ...(transactionsDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListTransactionsResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * lists transactions
 * @param transaction_type (optional) Transaction type
 * @return OK
 */
export function setTransactionsData(
    queryClient: QueryClient,
    updater: (
        data: Types.ListTransactionsResponse | undefined
    ) => Types.ListTransactionsResponse,
    transaction_type?: Types.Transaction_type | null | undefined
) {
    queryClient.setQueryData(transactionsQueryKey(transaction_type), updater);
}

/**
 * lists transactions
 * @param transaction_type (optional) Transaction type
 * @return OK
 */
export function setTransactionsDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListTransactionsResponse | undefined
    ) => Types.ListTransactionsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function courseGET2Url(): string {
    let url_ = getBaseUrl() + '/api/v1/course';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let courseGET2DefaultOptions: Omit<
    UseQueryOptions<
        Types.ListTrainingCoursesResponse,
        unknown,
        Types.ListTrainingCoursesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListTrainingCoursesResponse,
                unknown,
                Types.ListTrainingCoursesResponse
            >,
            'queryFn'
        >
    > = {};
export function getCourseGET2DefaultOptions() {
    return courseGET2DefaultOptions;
}
export function setCourseGET2DefaultOptions(
    options: typeof courseGET2DefaultOptions
) {
    courseGET2DefaultOptions = options;
}

export function courseGET2QueryKey(): QueryKey;
export function courseGET2QueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'courseGET2']);
}
export function __courseGET2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.courseGET2(axiosConfig);
}

/**
 * ListTrainingCourses
 * @return OK
 */
export function useCourseGET2Query<
    TSelectData = Types.ListTrainingCoursesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.ListTrainingCoursesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useCourseGET2Query<
    TSelectData = Types.ListTrainingCoursesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.ListTrainingCoursesResponse,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListTrainingCoursesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __courseGET2(context, axiosConfig)
            : __courseGET2,
        queryKey: courseGET2QueryKey(),
        ...(courseGET2DefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListTrainingCoursesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListTrainingCourses
 * @return OK
 */
export function setCourseGET2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.ListTrainingCoursesResponse | undefined
    ) => Types.ListTrainingCoursesResponse
) {
    queryClient.setQueryData(courseGET2QueryKey(), updater);
}

/**
 * ListTrainingCourses
 * @return OK
 */
export function setCourseGET2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListTrainingCoursesResponse | undefined
    ) => Types.ListTrainingCoursesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function coursePOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/course';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function coursePOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'coursePOST']);
}

/**
 * StartTrainingCourses
 * @param request Request
 * @return OK
 */
export function useCoursePOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.StartTrainingCourseResponse,
            unknown,
            Types.StartTrainingCourseRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.StartTrainingCourseResponse,
    unknown,
    Types.StartTrainingCourseRequest,
    TContext
> {
    const key = coursePOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.StartTrainingCourseRequest) =>
            Client.coursePOST(request),
        mutationKey: key,
    });
}

export function listUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/course/list';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let listDefaultOptions: Omit<
    UseQueryOptions<
        Types.ListRunningCoursesResponse,
        unknown,
        Types.ListRunningCoursesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListRunningCoursesResponse,
                unknown,
                Types.ListRunningCoursesResponse
            >,
            'queryFn'
        >
    > = {};
export function getListDefaultOptions() {
    return listDefaultOptions;
}
export function setListDefaultOptions(options: typeof listDefaultOptions) {
    listDefaultOptions = options;
}

export function listQueryKey(): QueryKey;
export function listQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'list']);
}
export function __list(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.list(axiosConfig);
}

/**
 * ListRunningCourses
 * @return OK
 */
export function useListQuery<
    TSelectData = Types.ListRunningCoursesResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.ListRunningCoursesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useListQuery<
    TSelectData = Types.ListRunningCoursesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListRunningCoursesResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListRunningCoursesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __list(context, axiosConfig)
            : __list,
        queryKey: listQueryKey(),
        ...(listDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListRunningCoursesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListRunningCourses
 * @return OK
 */
export function setListData(
    queryClient: QueryClient,
    updater: (
        data: Types.ListRunningCoursesResponse | undefined
    ) => Types.ListRunningCoursesResponse
) {
    queryClient.setQueryData(listQueryKey(), updater);
}

/**
 * ListRunningCourses
 * @return OK
 */
export function setListDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListRunningCoursesResponse | undefined
    ) => Types.ListRunningCoursesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function exampleUrl(id: number): string {
    let url_ = getBaseUrl() + '/api/v1/course/{id}/conversation/example';
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function exampleMutationKey(id: number): MutationKey {
    return trimArrayEnd(['Client', 'example', id as any]);
}

/**
 * TrainingCoursesGenerateExample
 * @param id ID
 * @param request Request
 * @return OK
 */
export function useExampleMutation<TContext>(
    id: number,
    options?: Omit<
        UseMutationOptions<
            Types.ConversationGenerateExampleResponse,
            unknown,
            Types.ConversationGenerateExampleRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.ConversationGenerateExampleResponse,
    unknown,
    Types.ConversationGenerateExampleRequest,
    TContext
> {
    const key = exampleMutationKey(id);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.ConversationGenerateExampleRequest) =>
            Client.example(id, request),
        mutationKey: key,
    });
}

type Example__MutationParameters = ExampleQueryParameters & {
    request: Types.ConversationGenerateExampleRequest;
};

/**
 * TrainingCoursesGenerateExample
 * @param id ID
 * @param request Request
 * @return OK
 */
export function useExampleMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.ConversationGenerateExampleResponse,
            unknown,
            Example__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: ExampleQueryParameters }
): UseMutationResult<
    Types.ConversationGenerateExampleResponse,
    unknown,
    Example__MutationParameters,
    TContext
> {
    const key = exampleMutationKey(options?.parameters?.id!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Example__MutationParameters) =>
            Client.example(data.id ?? options?.parameters?.id!, data.request),
        mutationKey: key,
    });
}

export function questionUrl(id: number): string {
    let url_ = getBaseUrl() + '/api/v1/course/{id}/conversation/question';
    if (id === undefined || id === null)
        throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function questionMutationKey(id: number): MutationKey {
    return trimArrayEnd(['Client', 'question', id as any]);
}

/**
 * TrainingCourseAskQuestion
 * @param id ID
 * @param request Request
 * @return OK
 */
export function useQuestionMutation<TContext>(
    id: number,
    options?: Omit<
        UseMutationOptions<
            Types.ConversationAskQuestionResponse,
            unknown,
            Types.ConversationAskQuestionRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.ConversationAskQuestionResponse,
    unknown,
    Types.ConversationAskQuestionRequest,
    TContext
> {
    const key = questionMutationKey(id);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.ConversationAskQuestionRequest) =>
            Client.question(id, request),
        mutationKey: key,
    });
}

type Question__MutationParameters = QuestionQueryParameters & {
    request: Types.ConversationAskQuestionRequest;
};

/**
 * TrainingCourseAskQuestion
 * @param id ID
 * @param request Request
 * @return OK
 */
export function useQuestionMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.ConversationAskQuestionResponse,
            unknown,
            Question__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: QuestionQueryParameters }
): UseMutationResult<
    Types.ConversationAskQuestionResponse,
    unknown,
    Question__MutationParameters,
    TContext
> {
    const key = questionMutationKey(options?.parameters?.id!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Question__MutationParameters) =>
            Client.question(data.id ?? options?.parameters?.id!, data.request),
        mutationKey: key,
    });
}

export function filesPOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/files';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function filesPOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'filesPOST']);
}

/**
 * Upload File
 * @param file File to upload (Excel, Word, PDF)
 * @return File uploaded successfully
 */
export function useFilesPOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.UploadFileResponse,
            unknown,
            FilesPOSTMutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.UploadFileResponse,
    unknown,
    FilesPOSTMutationParameters,
    TContext
> {
    const key = filesPOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (
            filesPOSTMutationParameters: FilesPOSTMutationParameters
        ) => Client.filesPOST(filesPOSTMutationParameters.file),
        mutationKey: key,
    });
}

export function userUrl(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source | null | undefined,
    fileExt?: string | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/files/user?';
    if (page !== undefined && page !== null)
        url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize !== undefined && pageSize !== null)
        url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (source !== undefined && source !== null)
        url_ += 'source=' + encodeURIComponent('' + source) + '&';
    if (fileExt !== undefined && fileExt !== null)
        url_ += 'fileExt=' + encodeURIComponent('' + fileExt) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let userDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetFilesListResponse,
        unknown,
        Types.GetFilesListResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetFilesListResponse,
                unknown,
                Types.GetFilesListResponse
            >,
            'queryFn'
        >
    > = {};
export function getUserDefaultOptions() {
    return userDefaultOptions;
}
export function setUserDefaultOptions(options: typeof userDefaultOptions) {
    userDefaultOptions = options;
}

export function userQueryKey(dto: UserQueryParameters): QueryKey;
export function userQueryKey(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source | null | undefined,
    fileExt?: string | null | undefined
): QueryKey;
export function userQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { page, pageSize, source, fileExt } =
            params[0] as UserQueryParameters;

        return trimArrayEnd([
            'Client',
            'user',
            page as any,
            pageSize as any,
            source as any,
            fileExt as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'user', ...params]);
    }
}
export function __user(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.user(
        context.queryKey[2] as number | null | undefined,
        context.queryKey[3] as number | null | undefined,
        context.queryKey[4] as Types.Source | null | undefined,
        context.queryKey[5] as string | null | undefined,
        axiosConfig
    );
}

export function useUserQuery<
    TSelectData = Types.GetFilesListResponse,
    TError = unknown
>(
    dto: UserQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.GetFilesListResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function useUserQuery<
    TSelectData = Types.GetFilesListResponse,
    TError = unknown
>(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source | null | undefined,
    fileExt?: string | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.GetFilesListResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useUserQuery<
    TSelectData = Types.GetFilesListResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetFilesListResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let page: any = undefined;
    let pageSize: any = undefined;
    let source: any = undefined;
    let fileExt: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ page, pageSize, source, fileExt } =
                params[0] as UserQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [page, pageSize, source, fileExt, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetFilesListResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __user(context, axiosConfig)
            : __user,
        queryKey: userQueryKey(page, pageSize, source, fileExt),
        ...(userDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetFilesListResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function setUserData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetFilesListResponse | undefined
    ) => Types.GetFilesListResponse,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source | null | undefined,
    fileExt?: string | null | undefined
) {
    queryClient.setQueryData(
        userQueryKey(page, pageSize, source, fileExt),
        updater
    );
}

/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function setUserDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetFilesListResponse | undefined
    ) => Types.GetFilesListResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function downloadUrl(fileId: string): string {
    let url_ = getBaseUrl() + '/api/v1/files/{fileId}/download';
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let downloadDefaultOptions: Omit<
    UseQueryOptions<number[], unknown, number[]>,
    'queryKey' | 'queryFn'
> &
    Partial<Pick<UseQueryOptions<number[], unknown, number[]>, 'queryFn'>> = {};
export function getDownloadDefaultOptions() {
    return downloadDefaultOptions;
}
export function setDownloadDefaultOptions(
    options: typeof downloadDefaultOptions
) {
    downloadDefaultOptions = options;
}

export function downloadQueryKey(fileId: string): QueryKey;
export function downloadQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { fileId } = params[0] as DownloadQueryParameters;

        return trimArrayEnd(['Client', 'download', fileId as any]);
    } else {
        return trimArrayEnd(['Client', 'download', ...params]);
    }
}
export function __download(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.download(context.queryKey[2] as string, axiosConfig);
}

export function useDownloadQuery<TSelectData = number[], TError = unknown>(
    dto: DownloadQueryParameters,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * DownloadUserFileByFileID
 * @param fileId FileID
 * @return OK
 */
export function useDownloadQuery<TSelectData = number[], TError = unknown>(
    fileId: string,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useDownloadQuery<TSelectData = number[], TError = unknown>(
    ...params: any[]
): UseQueryResult<TSelectData, TError> {
    let options: UseQueryOptions<number[], TError, TSelectData> | undefined =
        undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let fileId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ fileId } = params[0] as DownloadQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [fileId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<number[], TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __download(context, axiosConfig)
            : __download,
        queryKey: downloadQueryKey(fileId),
        ...(downloadDefaultOptions as unknown as Omit<
            UseQueryOptions<number[], TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * DownloadUserFileByFileID
 * @param fileId FileID
 * @return OK
 */
export function setDownloadData(
    queryClient: QueryClient,
    updater: (data: number[] | undefined) => number[],
    fileId: string
) {
    queryClient.setQueryData(downloadQueryKey(fileId), updater);
}

/**
 * DownloadUserFileByFileID
 * @param fileId FileID
 * @return OK
 */
export function setDownloadDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: number[] | undefined) => number[]
) {
    queryClient.setQueryData(queryKey, updater);
}

export function download2Url(fileId: string, userId: string): string {
    let url_ = getBaseUrl() + '/api/v1/files/{userId}/{fileId}/download';
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    if (userId === undefined || userId === null)
        throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let download2DefaultOptions: Omit<
    UseQueryOptions<number[], unknown, number[]>,
    'queryKey' | 'queryFn'
> &
    Partial<Pick<UseQueryOptions<number[], unknown, number[]>, 'queryFn'>> = {};
export function getDownload2DefaultOptions() {
    return download2DefaultOptions;
}
export function setDownload2DefaultOptions(
    options: typeof download2DefaultOptions
) {
    download2DefaultOptions = options;
}

export function download2QueryKey(dto: Download2QueryParameters): QueryKey;
export function download2QueryKey(fileId: string, userId: string): QueryKey;
export function download2QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { fileId, userId } = params[0] as Download2QueryParameters;

        return trimArrayEnd([
            'Client',
            'download2',
            fileId as any,
            userId as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'download2', ...params]);
    }
}
export function __download2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.download2(
        context.queryKey[2] as string,
        context.queryKey[3] as string,
        axiosConfig
    );
}

export function useDownload2Query<TSelectData = number[], TError = unknown>(
    dto: Download2QueryParameters,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * Download File By User And File ID
 * @param fileId File ID
 * @param userId User ID
 * @return OK
 */
export function useDownload2Query<TSelectData = number[], TError = unknown>(
    fileId: string,
    userId: string,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useDownload2Query<TSelectData = number[], TError = unknown>(
    ...params: any[]
): UseQueryResult<TSelectData, TError> {
    let options: UseQueryOptions<number[], TError, TSelectData> | undefined =
        undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let fileId: any = undefined;
    let userId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ fileId, userId } = params[0] as Download2QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [fileId, userId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<number[], TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __download2(context, axiosConfig)
            : __download2,
        queryKey: download2QueryKey(fileId, userId),
        ...(download2DefaultOptions as unknown as Omit<
            UseQueryOptions<number[], TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * Download File By User And File ID
 * @param fileId File ID
 * @param userId User ID
 * @return OK
 */
export function setDownload2Data(
    queryClient: QueryClient,
    updater: (data: number[] | undefined) => number[],
    fileId: string,
    userId: string
) {
    queryClient.setQueryData(download2QueryKey(fileId, userId), updater);
}

/**
 * Download File By User And File ID
 * @param fileId File ID
 * @param userId User ID
 * @return OK
 */
export function setDownload2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: number[] | undefined) => number[]
) {
    queryClient.setQueryData(queryKey, updater);
}

export function interviewGET2Url(
    categoryType?: Types.CategoryType | null | undefined,
    isCancelled?: boolean | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/interview?';
    if (categoryType !== undefined && categoryType !== null)
        url_ += 'categoryType=' + encodeURIComponent('' + categoryType) + '&';
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += 'isCancelled=' + encodeURIComponent('' + isCancelled) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let interviewGET2DefaultOptions: Omit<
    UseQueryOptions<
        Types.ListInterviewsResponse,
        unknown,
        Types.ListInterviewsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListInterviewsResponse,
                unknown,
                Types.ListInterviewsResponse
            >,
            'queryFn'
        >
    > = {};
export function getInterviewGET2DefaultOptions() {
    return interviewGET2DefaultOptions;
}
export function setInterviewGET2DefaultOptions(
    options: typeof interviewGET2DefaultOptions
) {
    interviewGET2DefaultOptions = options;
}

export function interviewGET2QueryKey(
    dto: InterviewGET2QueryParameters
): QueryKey;
export function interviewGET2QueryKey(
    categoryType?: Types.CategoryType | null | undefined,
    isCancelled?: boolean | null | undefined
): QueryKey;
export function interviewGET2QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { categoryType, isCancelled } =
            params[0] as InterviewGET2QueryParameters;

        return trimArrayEnd([
            'Client',
            'interviewGET2',
            categoryType as any,
            isCancelled as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'interviewGET2', ...params]);
    }
}
export function __interviewGET2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.interviewGET2(
        context.queryKey[2] as Types.CategoryType | null | undefined,
        context.queryKey[3] as boolean | null | undefined,
        axiosConfig
    );
}

export function useInterviewGET2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(
    dto: InterviewGET2QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * ListInterviews
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function useInterviewGET2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(
    categoryType?: Types.CategoryType | null | undefined,
    isCancelled?: boolean | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useInterviewGET2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let categoryType: any = undefined;
    let isCancelled: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ categoryType, isCancelled } =
                params[0] as InterviewGET2QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [categoryType, isCancelled, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListInterviewsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __interviewGET2(context, axiosConfig)
            : __interviewGET2,
        queryKey: interviewGET2QueryKey(categoryType, isCancelled),
        ...(interviewGET2DefaultOptions as unknown as Omit<
            UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListInterviews
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function setInterviewGET2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.ListInterviewsResponse | undefined
    ) => Types.ListInterviewsResponse,
    categoryType?: Types.CategoryType | null | undefined,
    isCancelled?: boolean | null | undefined
) {
    queryClient.setQueryData(
        interviewGET2QueryKey(categoryType, isCancelled),
        updater
    );
}

/**
 * ListInterviews
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @return OK
 */
export function setInterviewGET2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListInterviewsResponse | undefined
    ) => Types.ListInterviewsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function interviewPOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function interviewPOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'interviewPOST']);
}

/**
 * CreateInterview
 * @param request Request
 * @return OK
 */
export function useInterviewPOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.CreateInterviewResponse,
            unknown,
            Types.CreateInterviewRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.CreateInterviewResponse,
    unknown,
    Types.CreateInterviewRequest,
    TContext
> {
    const key = interviewPOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.CreateInterviewRequest) =>
            Client.interviewPOST(request),
        mutationKey: key,
    });
}

export function categoriesTypeUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/categories-type';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let categoriesTypeDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetListOfInterviewCategoriesType,
        unknown,
        Types.GetListOfInterviewCategoriesType
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetListOfInterviewCategoriesType,
                unknown,
                Types.GetListOfInterviewCategoriesType
            >,
            'queryFn'
        >
    > = {};
export function getCategoriesTypeDefaultOptions() {
    return categoriesTypeDefaultOptions;
}
export function setCategoriesTypeDefaultOptions(
    options: typeof categoriesTypeDefaultOptions
) {
    categoriesTypeDefaultOptions = options;
}

export function categoriesTypeQueryKey(): QueryKey;
export function categoriesTypeQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'categoriesType']);
}
export function __categoriesType(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.categoriesType(axiosConfig);
}

/**
 * GetListOfInterviewCategoriesType
 * @return OK
 */
export function useCategoriesTypeQuery<
    TSelectData = Types.GetListOfInterviewCategoriesType,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<
            Types.GetListOfInterviewCategoriesType,
            TError,
            TSelectData
        >,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useCategoriesTypeQuery<
    TSelectData = Types.GetListOfInterviewCategoriesType,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<
              Types.GetListOfInterviewCategoriesType,
              TError,
              TSelectData
          >
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<
        Types.GetListOfInterviewCategoriesType,
        TError,
        TSelectData
    >({
        queryFn: axiosConfig
            ? (context) => __categoriesType(context, axiosConfig)
            : __categoriesType,
        queryKey: categoriesTypeQueryKey(),
        ...(categoriesTypeDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetListOfInterviewCategoriesType,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * GetListOfInterviewCategoriesType
 * @return OK
 */
export function setCategoriesTypeData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetListOfInterviewCategoriesType | undefined
    ) => Types.GetListOfInterviewCategoriesType
) {
    queryClient.setQueryData(categoriesTypeQueryKey(), updater);
}

/**
 * GetListOfInterviewCategoriesType
 * @return OK
 */
export function setCategoriesTypeDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetListOfInterviewCategoriesType | undefined
    ) => Types.GetListOfInterviewCategoriesType
) {
    queryClient.setQueryData(queryKey, updater);
}

export function generalAllUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/files/general';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function generalAllMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'generalAll']);
}

/**
 * Generate General Interview Types
 * @param request List of file IDs to process
 * @return Generated interview types
 */
export function useGeneralAllMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.InterviewType[],
            unknown,
            Types.GenerateJobInterviewTypesByFilesRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.InterviewType[],
    unknown,
    Types.GenerateJobInterviewTypesByFilesRequest,
    TContext
> {
    const key = generalAllMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.GenerateJobInterviewTypesByFilesRequest) =>
            Client.generalAll(request),
        mutationKey: key,
    });
}

export function jobUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/files/job';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function jobMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'job']);
}

/**
 * Generate Job Interview Types
 * @param request List of file IDs to process
 * @return Generated interview types
 */
export function useJobMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.InterviewType[],
            unknown,
            Types.GenerateJobInterviewTypesByFilesRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.InterviewType[],
    unknown,
    Types.GenerateJobInterviewTypesByFilesRequest,
    TContext
> {
    const key = jobMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.GenerateJobInterviewTypesByFilesRequest) =>
            Client.job(request),
        mutationKey: key,
    });
}

export function generalUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/generate/general';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function generalMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'general']);
}

/**
 * GenerateGeneralInterviewTypes
 * @param request Request
 * @return OK
 */
export function useGeneralMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.InterviewType,
            unknown,
            Types.GenerateGeneralInterviewRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.InterviewType,
    unknown,
    Types.GenerateGeneralInterviewRequest,
    TContext
> {
    const key = generalMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.GenerateGeneralInterviewRequest) =>
            Client.general(request),
        mutationKey: key,
    });
}

export function job2Url(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/generate/job';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function job2MutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'job2']);
}

/**
 * GenerateJobInterviewTypes
 * @param request Request
 * @return OK
 */
export function useJob2Mutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.InterviewType[],
            unknown,
            Types.GenerateJobInterviewRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.InterviewType[],
    unknown,
    Types.GenerateJobInterviewRequest,
    TContext
> {
    const key = job2MutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.GenerateJobInterviewRequest) =>
            Client.job2(request),
        mutationKey: key,
    });
}

export function page2Url(
    categoryType?: Types.CategoryType2 | null | undefined,
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/interview/page?';
    if (categoryType !== undefined && categoryType !== null)
        url_ += 'categoryType=' + encodeURIComponent('' + categoryType) + '&';
    if (isCancelled !== undefined && isCancelled !== null)
        url_ += 'isCancelled=' + encodeURIComponent('' + isCancelled) + '&';
    if (page !== undefined && page !== null)
        url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize !== undefined && pageSize !== null)
        url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let page2DefaultOptions: Omit<
    UseQueryOptions<
        Types.ListInterviewsResponse,
        unknown,
        Types.ListInterviewsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListInterviewsResponse,
                unknown,
                Types.ListInterviewsResponse
            >,
            'queryFn'
        >
    > = {};
export function getPage2DefaultOptions() {
    return page2DefaultOptions;
}
export function setPage2DefaultOptions(options: typeof page2DefaultOptions) {
    page2DefaultOptions = options;
}

export function page2QueryKey(dto: Page2QueryParameters): QueryKey;
export function page2QueryKey(
    categoryType?: Types.CategoryType2 | null | undefined,
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
): QueryKey;
export function page2QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { categoryType, isCancelled, page, pageSize } =
            params[0] as Page2QueryParameters;

        return trimArrayEnd([
            'Client',
            'page2',
            categoryType as any,
            isCancelled as any,
            page as any,
            pageSize as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'page2', ...params]);
    }
}
export function __page2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.page2(
        context.queryKey[2] as Types.CategoryType2 | null | undefined,
        context.queryKey[3] as boolean | null | undefined,
        context.queryKey[4] as number | null | undefined,
        context.queryKey[5] as number | null | undefined,
        axiosConfig
    );
}

export function usePage2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(
    dto: Page2QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * ListInterviewsPageable
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function usePage2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(
    categoryType?: Types.CategoryType2 | null | undefined,
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function usePage2Query<
    TSelectData = Types.ListInterviewsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let categoryType: any = undefined;
    let isCancelled: any = undefined;
    let page: any = undefined;
    let pageSize: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ categoryType, isCancelled, page, pageSize } =
                params[0] as Page2QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [categoryType, isCancelled, page, pageSize, options, axiosConfig] =
                params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListInterviewsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __page2(context, axiosConfig)
            : __page2,
        queryKey: page2QueryKey(categoryType, isCancelled, page, pageSize),
        ...(page2DefaultOptions as unknown as Omit<
            UseQueryOptions<Types.ListInterviewsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListInterviewsPageable
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function setPage2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.ListInterviewsResponse | undefined
    ) => Types.ListInterviewsResponse,
    categoryType?: Types.CategoryType2 | null | undefined,
    isCancelled?: boolean | null | undefined,
    page?: number | null | undefined,
    pageSize?: number | null | undefined
) {
    queryClient.setQueryData(
        page2QueryKey(categoryType, isCancelled, page, pageSize),
        updater
    );
}

/**
 * ListInterviewsPageable
 * @param categoryType (optional) Category Type
 * @param isCancelled (optional) Filter by cancellation status
 * @param page (optional) Page number
 * @param pageSize (optional) Number of items per page
 * @return OK
 */
export function setPage2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListInterviewsResponse | undefined
    ) => Types.ListInterviewsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function requestUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/interview/request';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function requestMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'request']);
}

/**
 * RequestInterviewTypes
 * @param request Request
 * @return OK
 */
export function useRequestMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.RequestInterviewResponse,
            unknown,
            Types.RequestInterviewRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.RequestInterviewResponse,
    unknown,
    Types.RequestInterviewRequest,
    TContext
> {
    const key = requestMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.RequestInterviewRequest) =>
            Client.request(request),
        mutationKey: key,
    });
}

export function typesGET2Url(
    categoryType?: Types.CategoryType3 | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/interview/types?';
    if (categoryType !== undefined && categoryType !== null)
        url_ += 'categoryType=' + encodeURIComponent('' + categoryType) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let typesGET2DefaultOptions: Omit<
    UseQueryOptions<
        Types.ListInterviewTypesResponse,
        unknown,
        Types.ListInterviewTypesResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ListInterviewTypesResponse,
                unknown,
                Types.ListInterviewTypesResponse
            >,
            'queryFn'
        >
    > = {};
export function getTypesGET2DefaultOptions() {
    return typesGET2DefaultOptions;
}
export function setTypesGET2DefaultOptions(
    options: typeof typesGET2DefaultOptions
) {
    typesGET2DefaultOptions = options;
}

export function typesGET2QueryKey(
    categoryType?: Types.CategoryType3 | null | undefined
): QueryKey;
export function typesGET2QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { categoryType } = params[0] as TypesGET2QueryParameters;

        return trimArrayEnd(['Client', 'typesGET2', categoryType as any]);
    } else {
        return trimArrayEnd(['Client', 'typesGET2', ...params]);
    }
}
export function __typesGET2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.typesGET2(
        context.queryKey[2] as Types.CategoryType3 | null | undefined,
        axiosConfig
    );
}

export function useTypesGET2Query<
    TSelectData = Types.ListInterviewTypesResponse,
    TError = unknown
>(
    dto: TypesGET2QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewTypesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * ListInterviewTypes
 * @param categoryType (optional) Category Type
 * @return OK
 */
export function useTypesGET2Query<
    TSelectData = Types.ListInterviewTypesResponse,
    TError = unknown
>(
    categoryType?: Types.CategoryType3 | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.ListInterviewTypesResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useTypesGET2Query<
    TSelectData = Types.ListInterviewTypesResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ListInterviewTypesResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let categoryType: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ categoryType } = params[0] as TypesGET2QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [categoryType, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ListInterviewTypesResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __typesGET2(context, axiosConfig)
            : __typesGET2,
        queryKey: typesGET2QueryKey(categoryType),
        ...(typesGET2DefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.ListInterviewTypesResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * ListInterviewTypes
 * @param categoryType (optional) Category Type
 * @return OK
 */
export function setTypesGET2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.ListInterviewTypesResponse | undefined
    ) => Types.ListInterviewTypesResponse,
    categoryType?: Types.CategoryType3 | null | undefined
) {
    queryClient.setQueryData(typesGET2QueryKey(categoryType), updater);
}

/**
 * ListInterviewTypes
 * @param categoryType (optional) Category Type
 * @return OK
 */
export function setTypesGET2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.ListInterviewTypesResponse | undefined
    ) => Types.ListInterviewTypesResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function typesDELETEUrl(interviewTypeId: string): string {
    let url_ = getBaseUrl() + '/api/v1/interview/types/{interviewTypeId}';
    if (interviewTypeId === undefined || interviewTypeId === null)
        throw new Error("The parameter 'interviewTypeId' must be defined.");
    url_ = url_.replace(
        '{interviewTypeId}',
        encodeURIComponent('' + interviewTypeId)
    );
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function typesDELETEMutationKey(interviewTypeId: string): MutationKey {
    return trimArrayEnd(['Client', 'typesDELETE', interviewTypeId as any]);
}

/**
 * DeleteInterviewType
 * @param interviewTypeId Interview type id
 * @return OK
 */
export function useTypesDELETEMutation<TContext>(
    interviewTypeId: string,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = typesDELETEMutationKey(interviewTypeId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.typesDELETE(interviewTypeId),
        mutationKey: key,
    });
}

type TypesDELETE__MutationParameters = TypesDELETEQueryParameters;

/**
 * DeleteInterviewType
 * @param interviewTypeId Interview type id
 * @return OK
 */
export function useTypesDELETEMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            TypesDELETE__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: TypesDELETEQueryParameters }
): UseMutationResult<void, unknown, TypesDELETE__MutationParameters, TContext> {
    const key = typesDELETEMutationKey(options?.parameters?.interviewTypeId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: TypesDELETE__MutationParameters) =>
            Client.typesDELETE(
                data.interviewTypeId ?? options?.parameters?.interviewTypeId!
            ),
        mutationKey: key,
    });
}

export function interviewGET3Url(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let interviewGET3DefaultOptions: Omit<
    UseQueryOptions<
        Types.GetInterviewsResponse,
        unknown,
        Types.GetInterviewsResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetInterviewsResponse,
                unknown,
                Types.GetInterviewsResponse
            >,
            'queryFn'
        >
    > = {};
export function getInterviewGET3DefaultOptions() {
    return interviewGET3DefaultOptions;
}
export function setInterviewGET3DefaultOptions(
    options: typeof interviewGET3DefaultOptions
) {
    interviewGET3DefaultOptions = options;
}

export function interviewGET3QueryKey(interviewId: number): QueryKey;
export function interviewGET3QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { interviewId } = params[0] as InterviewGET3QueryParameters;

        return trimArrayEnd(['Client', 'interviewGET3', interviewId as any]);
    } else {
        return trimArrayEnd(['Client', 'interviewGET3', ...params]);
    }
}
export function __interviewGET3(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.interviewGET3(context.queryKey[2] as number, axiosConfig);
}

export function useInterviewGET3Query<
    TSelectData = Types.GetInterviewsResponse,
    TError = unknown
>(
    dto: InterviewGET3QueryParameters,
    options?: Omit<
        UseQueryOptions<Types.GetInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * GetInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function useInterviewGET3Query<
    TSelectData = Types.GetInterviewsResponse,
    TError = unknown
>(
    interviewId: number,
    options?: Omit<
        UseQueryOptions<Types.GetInterviewsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useInterviewGET3Query<
    TSelectData = Types.GetInterviewsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetInterviewsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let interviewId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ interviewId } = params[0] as InterviewGET3QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [interviewId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetInterviewsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __interviewGET3(context, axiosConfig)
            : __interviewGET3,
        queryKey: interviewGET3QueryKey(interviewId),
        ...(interviewGET3DefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetInterviewsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * GetInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function setInterviewGET3Data(
    queryClient: QueryClient,
    updater: (
        data: Types.GetInterviewsResponse | undefined
    ) => Types.GetInterviewsResponse,
    interviewId: number
) {
    queryClient.setQueryData(interviewGET3QueryKey(interviewId), updater);
}

/**
 * GetInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function setInterviewGET3DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetInterviewsResponse | undefined
    ) => Types.GetInterviewsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function interviewDELETEUrl(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function interviewDELETEMutationKey(interviewId: number): MutationKey {
    return trimArrayEnd(['Client', 'interviewDELETE', interviewId as any]);
}

/**
 * CancelInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function useInterviewDELETEMutation<TContext>(
    interviewId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = interviewDELETEMutationKey(interviewId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.interviewDELETE(interviewId),
        mutationKey: key,
    });
}

type InterviewDELETE__MutationParameters = InterviewDELETEQueryParameters;

/**
 * CancelInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function useInterviewDELETEMutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            InterviewDELETE__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: InterviewDELETEQueryParameters }
): UseMutationResult<
    void,
    unknown,
    InterviewDELETE__MutationParameters,
    TContext
> {
    const key = interviewDELETEMutationKey(options?.parameters?.interviewId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: InterviewDELETE__MutationParameters) =>
            Client.interviewDELETE(
                data.interviewId ?? options?.parameters?.interviewId!
            ),
        mutationKey: key,
    });
}

export function continue2Url(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}/continue';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function continue2MutationKey(interviewId: number): MutationKey {
    return trimArrayEnd(['Client', 'continue2', interviewId as any]);
}

/**
 * ContinueInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function useContinue2Mutation<TContext>(
    interviewId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = continue2MutationKey(interviewId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.continue2(interviewId),
        mutationKey: key,
    });
}

type Continue2__MutationParameters = Continue2QueryParameters;

/**
 * ContinueInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function useContinue2MutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Continue2__MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    > & { parameters?: Continue2QueryParameters }
): UseMutationResult<void, unknown, Continue2__MutationParameters, TContext> {
    const key = continue2MutationKey(options?.parameters?.interviewId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Continue2__MutationParameters) =>
            Client.continue2(
                data.interviewId ?? options?.parameters?.interviewId!
            ),
        mutationKey: key,
    });
}

export function pause2Url(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}/pause';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function pause2MutationKey(interviewId: number): MutationKey {
    return trimArrayEnd(['Client', 'pause2', interviewId as any]);
}

/**
 * PauseInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function usePause2Mutation<TContext>(
    interviewId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = pause2MutationKey(interviewId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.pause2(interviewId),
        mutationKey: key,
    });
}

type Pause2__MutationParameters = Pause2QueryParameters;

/**
 * PauseInterview
 * @param interviewId Interview ID
 * @return OK
 */
export function usePause2MutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Pause2__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: Pause2QueryParameters }
): UseMutationResult<void, unknown, Pause2__MutationParameters, TContext> {
    const key = pause2MutationKey(options?.parameters?.interviewId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Pause2__MutationParameters) =>
            Client.pause2(
                data.interviewId ?? options?.parameters?.interviewId!
            ),
        mutationKey: key,
    });
}

export function text2Url(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}/respond/text';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function text2MutationKey(interviewId: number): MutationKey {
    return trimArrayEnd(['Client', 'text2', interviewId as any]);
}

/**
 * RespondToInterviewText
 * @param interviewId Interview ID
 * @param request Request
 * @return OK
 */
export function useText2Mutation<TContext>(
    interviewId: number,
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Types.RespondToInterviewTextRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    void,
    unknown,
    Types.RespondToInterviewTextRequest,
    TContext
> {
    const key = text2MutationKey(interviewId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.RespondToInterviewTextRequest) =>
            Client.text2(interviewId, request),
        mutationKey: key,
    });
}

type Text2__MutationParameters = Text2QueryParameters & {
    request: Types.RespondToInterviewTextRequest;
};

/**
 * RespondToInterviewText
 * @param interviewId Interview ID
 * @param request Request
 * @return OK
 */
export function useText2MutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Text2__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: Text2QueryParameters }
): UseMutationResult<void, unknown, Text2__MutationParameters, TContext> {
    const key = text2MutationKey(options?.parameters?.interviewId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Text2__MutationParameters) =>
            Client.text2(
                data.interviewId ?? options?.parameters?.interviewId!,
                data.request
            ),
        mutationKey: key,
    });
}

export function voice2Url(interviewId: number): string {
    let url_ = getBaseUrl() + '/api/v1/interview/{interviewId}/respond/voice';
    if (interviewId === undefined || interviewId === null)
        throw new Error("The parameter 'interviewId' must be defined.");
    url_ = url_.replace('{interviewId}', encodeURIComponent('' + interviewId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function voice2MutationKey(interviewId: number): MutationKey {
    return trimArrayEnd(['Client', 'voice2', interviewId as any]);
}

/**
 * RespondToInterviewVoice
 * @param interviewId Interview ID
 * @param voice_response The response voice file
 * @return OK
 */
export function useVoice2Mutation<TContext>(
    interviewId: number,
    options?: Omit<
        UseMutationOptions<void, unknown, Voice2MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Voice2MutationParameters, TContext> {
    const key = voice2MutationKey(interviewId);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (voice2MutationParameters: Voice2MutationParameters) =>
            Client.voice2(interviewId, voice2MutationParameters.voice_response),
        mutationKey: key,
    });
}

type Voice2__MutationParameters = Voice2QueryParameters & {
    voice2MutationParameters: Voice2MutationParameters;
};

/**
 * RespondToInterviewVoice
 * @param interviewId Interview ID
 * @param voice_response The response voice file
 * @return OK
 */
export function useVoice2MutationWithParameters<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Voice2__MutationParameters, TContext>,
        'mutationKey' | 'mutationFn'
    > & { parameters?: Voice2QueryParameters }
): UseMutationResult<void, unknown, Voice2__MutationParameters, TContext> {
    const key = voice2MutationKey(options?.parameters?.interviewId!);

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (data: Voice2__MutationParameters) =>
            Client.voice2(data.interviewId, data.voice_response),
        mutationKey: key,
    });
}

export function jobsUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/jobs';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let jobsDefaultOptions: Omit<
    UseQueryOptions<Types.JobsResponse, unknown, Types.JobsResponse>,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<Types.JobsResponse, unknown, Types.JobsResponse>,
            'queryFn'
        >
    > = {};
export function getJobsDefaultOptions() {
    return jobsDefaultOptions;
}
export function setJobsDefaultOptions(options: typeof jobsDefaultOptions) {
    jobsDefaultOptions = options;
}

export function jobsQueryKey(): QueryKey;
export function jobsQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'jobs']);
}
export function __jobs(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.jobs(axiosConfig);
}

/**
 * Jobs
 * @return OK
 */
export function useJobsQuery<
    TSelectData = Types.JobsResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.JobsResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useJobsQuery<
    TSelectData = Types.JobsResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.JobsResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.JobsResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __jobs(context, axiosConfig)
            : __jobs,
        queryKey: jobsQueryKey(),
        ...(jobsDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.JobsResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * Jobs
 * @return OK
 */
export function setJobsData(
    queryClient: QueryClient,
    updater: (data: Types.JobsResponse | undefined) => Types.JobsResponse
) {
    queryClient.setQueryData(jobsQueryKey(), updater);
}

/**
 * Jobs
 * @return OK
 */
export function setJobsDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: Types.JobsResponse | undefined) => Types.JobsResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function resumeUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/login/resume';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function resumeMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'resume']);
}

/**
 * LoginByResume
 * @param file The file
 * @return OK
 */
export function useResumeMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.LoginByResumeResponse,
            unknown,
            ResumeMutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.LoginByResumeResponse,
    unknown,
    ResumeMutationParameters,
    TContext
> {
    const key = resumeMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (resumeMutationParameters: ResumeMutationParameters) =>
            Client.resume(resumeMutationParameters.file),
        mutationKey: key,
    });
}

export function aboutMeUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/describe/about-me';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function aboutMeMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'aboutMe']);
}

/**
 * describe user
 * @return OK
 */
export function useAboutMeMutation<TContext>(
    options?: Omit<
        UseMutationOptions<Types.DescribeResponse, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<Types.DescribeResponse, unknown, void, TContext> {
    const key = aboutMeMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.aboutMe(),
        mutationKey: key,
    });
}

export function projectsUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/describe/projects';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function projectsMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'projects']);
}

/**
 * describe user's projects
 * @param request Request
 * @return OK
 */
export function useProjectsMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.DescribeResponse,
            unknown,
            Types.Project,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<Types.DescribeResponse, unknown, Types.Project, TContext> {
    const key = projectsMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.Project) => Client.projects(request),
        mutationKey: key,
    });
}

export function workExperienceUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/describe/work-experience';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function workExperienceMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'workExperience']);
}

/**
 * describe user's work experience
 * @param request Request
 * @return OK
 */
export function useWorkExperienceMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.DescribeResponse,
            unknown,
            Types.Experience,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.DescribeResponse,
    unknown,
    Types.Experience,
    TContext
> {
    const key = workExperienceMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.Experience) =>
            Client.workExperience(request),
        mutationKey: key,
    });
}

export function resume2Url(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/resume';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function resume2MutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'resume2']);
}

/**
 * UpdateByResume
 * @param file The file
 * @return OK
 */
export function useResume2Mutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.UserDetails,
            unknown,
            Resume2MutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.UserDetails,
    unknown,
    Resume2MutationParameters,
    TContext
> {
    const key = resume2MutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (resume2MutationParameters: Resume2MutationParameters) =>
            Client.resume2(resume2MutationParameters.file),
        mutationKey: key,
    });
}

export function descriptionUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/skills/description';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function descriptionMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'description']);
}

/**
 * suggests skills for the provided description
 * @param request Request
 * @return OK
 */
export function useDescriptionMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.SkillBasedOnDescriptionResponse,
            unknown,
            Types.SkillBasedOnDescriptionRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.SkillBasedOnDescriptionResponse,
    unknown,
    Types.SkillBasedOnDescriptionRequest,
    TContext
> {
    const key = descriptionMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.SkillBasedOnDescriptionRequest) =>
            Client.description(request),
        mutationKey: key,
    });
}

export function graph2Url(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/skills/score/graph';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let graph2DefaultOptions: Omit<
    UseQueryOptions<
        Types.GetSkillScoreGraphResponse,
        unknown,
        Types.GetSkillScoreGraphResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetSkillScoreGraphResponse,
                unknown,
                Types.GetSkillScoreGraphResponse
            >,
            'queryFn'
        >
    > = {};
export function getGraph2DefaultOptions() {
    return graph2DefaultOptions;
}
export function setGraph2DefaultOptions(options: typeof graph2DefaultOptions) {
    graph2DefaultOptions = options;
}

export function graph2QueryKey(): QueryKey;
export function graph2QueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'graph2']);
}
export function __graph2(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.graph2(axiosConfig);
}

/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function useGraph2Query<
    TSelectData = Types.GetSkillScoreGraphResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetSkillScoreGraphResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useGraph2Query<
    TSelectData = Types.GetSkillScoreGraphResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetSkillScoreGraphResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetSkillScoreGraphResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __graph2(context, axiosConfig)
            : __graph2,
        queryKey: graph2QueryKey(),
        ...(graph2DefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetSkillScoreGraphResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function setGraph2Data(
    queryClient: QueryClient,
    updater: (
        data: Types.GetSkillScoreGraphResponse | undefined
    ) => Types.GetSkillScoreGraphResponse
) {
    queryClient.setQueryData(graph2QueryKey(), updater);
}

/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function setGraph2DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetSkillScoreGraphResponse | undefined
    ) => Types.GetSkillScoreGraphResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function suggestUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/skills/suggest';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function suggestMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'suggest']);
}

/**
 * suggests new skills for the user to add to his list of skills
 * @return OK
 */
export function useSuggestMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.SuggestNewSkillsResponse,
            unknown,
            void,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<Types.SuggestNewSkillsResponse, unknown, void, TContext> {
    const key = suggestMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.suggest(),
        mutationKey: key,
    });
}

export function certificatesUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/profile/suggest/certificates';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function certificatesMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'certificates']);
}

/**
 * suggests new certificates for the user to get
 * @return OK
 */
export function useCertificatesMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.SuggestNewCertificatesResponse,
            unknown,
            void,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.SuggestNewCertificatesResponse,
    unknown,
    void,
    TContext
> {
    const key = certificatesMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.certificates(),
        mutationKey: key,
    });
}

export function emailUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/signup/email';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function emailMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'email']);
}

/**
 * SignUpEmail
 * @param request Request
 * @return OK
 */
export function useEmailMutation<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Types.SignUpEmailRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Types.SignUpEmailRequest, TContext> {
    const key = emailMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.SignUpEmailRequest) =>
            Client.email(request),
        mutationKey: key,
    });
}

export function passwordUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/signup/password';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function passwordMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'password']);
}

/**
 * SignUpPassword
 * @param request Request
 * @return OK
 */
export function usePasswordMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Types.SignUpPasswordRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Types.SignUpPasswordRequest, TContext> {
    const key = passwordMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.SignUpPasswordRequest) =>
            Client.password(request),
        mutationKey: key,
    });
}

export function filesGETUrl(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source2 | null | undefined,
    fileExt?: string | null | undefined
): string {
    let url_ = getBaseUrl() + '/api/v1/user/files?';
    if (page !== undefined && page !== null)
        url_ += 'page=' + encodeURIComponent('' + page) + '&';
    if (pageSize !== undefined && pageSize !== null)
        url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (source !== undefined && source !== null)
        url_ += 'source=' + encodeURIComponent('' + source) + '&';
    if (fileExt !== undefined && fileExt !== null)
        url_ += 'fileExt=' + encodeURIComponent('' + fileExt) + '&';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let filesGETDefaultOptions: Omit<
    UseQueryOptions<
        Types.GetUserFilesListResponse,
        unknown,
        Types.GetUserFilesListResponse
    >,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.GetUserFilesListResponse,
                unknown,
                Types.GetUserFilesListResponse
            >,
            'queryFn'
        >
    > = {};
export function getFilesGETDefaultOptions() {
    return filesGETDefaultOptions;
}
export function setFilesGETDefaultOptions(
    options: typeof filesGETDefaultOptions
) {
    filesGETDefaultOptions = options;
}

export function filesGETQueryKey(dto: FilesGETQueryParameters): QueryKey;
export function filesGETQueryKey(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source2 | null | undefined,
    fileExt?: string | null | undefined
): QueryKey;
export function filesGETQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { page, pageSize, source, fileExt } =
            params[0] as FilesGETQueryParameters;

        return trimArrayEnd([
            'Client',
            'filesGET',
            page as any,
            pageSize as any,
            source as any,
            fileExt as any,
        ]);
    } else {
        return trimArrayEnd(['Client', 'filesGET', ...params]);
    }
}
export function __filesGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.filesGET(
        context.queryKey[2] as number | null | undefined,
        context.queryKey[3] as number | null | undefined,
        context.queryKey[4] as Types.Source2 | null | undefined,
        context.queryKey[5] as string | null | undefined,
        axiosConfig
    );
}

export function useFilesGETQuery<
    TSelectData = Types.GetUserFilesListResponse,
    TError = unknown
>(
    dto: FilesGETQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.GetUserFilesListResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function useFilesGETQuery<
    TSelectData = Types.GetUserFilesListResponse,
    TError = unknown
>(
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source2 | null | undefined,
    fileExt?: string | null | undefined,
    options?: Omit<
        UseQueryOptions<Types.GetUserFilesListResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useFilesGETQuery<
    TSelectData = Types.GetUserFilesListResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetUserFilesListResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let page: any = undefined;
    let pageSize: any = undefined;
    let source: any = undefined;
    let fileExt: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ page, pageSize, source, fileExt } =
                params[0] as FilesGETQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [page, pageSize, source, fileExt, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetUserFilesListResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __filesGET(context, axiosConfig)
            : __filesGET,
        queryKey: filesGETQueryKey(page, pageSize, source, fileExt),
        ...(filesGETDefaultOptions as unknown as Omit<
            UseQueryOptions<
                Types.GetUserFilesListResponse,
                TError,
                TSelectData
            >,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function setFilesGETData(
    queryClient: QueryClient,
    updater: (
        data: Types.GetUserFilesListResponse | undefined
    ) => Types.GetUserFilesListResponse,
    page?: number | null | undefined,
    pageSize?: number | null | undefined,
    source?: Types.Source2 | null | undefined,
    fileExt?: string | null | undefined
) {
    queryClient.setQueryData(
        filesGETQueryKey(page, pageSize, source, fileExt),
        updater
    );
}

/**
 * Get User Files
 * @param page (optional) Page number (default: 0)
 * @param pageSize (optional) Number of items per page (default: 5)
 * @param source (optional) Filter files by source (optional)
 * @param fileExt (optional) Filter files by file extension (optional)
 * @return List of user files
 */
export function setFilesGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (
        data: Types.GetUserFilesListResponse | undefined
    ) => Types.GetUserFilesListResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function filesPUTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/files';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function filesPUTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'filesPUT']);
}

/**
 * UploadUserFile
 * @param file The file
 * @return OK
 */
export function useFilesPUTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            string,
            unknown,
            FilesPUTMutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<string, unknown, FilesPUTMutationParameters, TContext> {
    const key = filesPUTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (filesPUTMutationParameters: FilesPUTMutationParameters) =>
            Client.filesPUT(filesPUTMutationParameters.file),
        mutationKey: key,
    });
}

export function streamUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/files/stream';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function streamMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'stream']);
}

/**
 * Upload User File Stream
 * @param file The file
 * @return OK
 */
export function useStreamMutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            Types.UploadFileStreamResponse,
            unknown,
            StreamMutationParameters,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<
    Types.UploadFileStreamResponse,
    unknown,
    StreamMutationParameters,
    TContext
> {
    const key = streamMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (streamMutationParameters: StreamMutationParameters) =>
            Client.stream(streamMutationParameters.file),
        mutationKey: key,
    });
}

export function download3Url(fileId: string): string {
    let url_ = getBaseUrl() + '/api/v1/user/files/{fileId}/download';
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let download3DefaultOptions: Omit<
    UseQueryOptions<number[], unknown, number[]>,
    'queryKey' | 'queryFn'
> &
    Partial<Pick<UseQueryOptions<number[], unknown, number[]>, 'queryFn'>> = {};
export function getDownload3DefaultOptions() {
    return download3DefaultOptions;
}
export function setDownload3DefaultOptions(
    options: typeof download3DefaultOptions
) {
    download3DefaultOptions = options;
}

export function download3QueryKey(fileId: string): QueryKey;
export function download3QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { fileId } = params[0] as Download3QueryParameters;

        return trimArrayEnd(['Client', 'download3', fileId as any]);
    } else {
        return trimArrayEnd(['Client', 'download3', ...params]);
    }
}
export function __download3(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.download3(context.queryKey[2] as string, axiosConfig);
}

export function useDownload3Query<TSelectData = number[], TError = unknown>(
    dto: Download3QueryParameters,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * DownloadUserFile
 * @param fileId FileID
 * @return OK
 */
export function useDownload3Query<TSelectData = number[], TError = unknown>(
    fileId: string,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useDownload3Query<TSelectData = number[], TError = unknown>(
    ...params: any[]
): UseQueryResult<TSelectData, TError> {
    let options: UseQueryOptions<number[], TError, TSelectData> | undefined =
        undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let fileId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ fileId } = params[0] as Download3QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [fileId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<number[], TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __download3(context, axiosConfig)
            : __download3,
        queryKey: download3QueryKey(fileId),
        ...(download3DefaultOptions as unknown as Omit<
            UseQueryOptions<number[], TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * DownloadUserFile
 * @param fileId FileID
 * @return OK
 */
export function setDownload3Data(
    queryClient: QueryClient,
    updater: (data: number[] | undefined) => number[],
    fileId: string
) {
    queryClient.setQueryData(download3QueryKey(fileId), updater);
}

/**
 * DownloadUserFile
 * @param fileId FileID
 * @return OK
 */
export function setDownload3DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: number[] | undefined) => number[]
) {
    queryClient.setQueryData(queryKey, updater);
}

export function download4Url(fileId: string): string {
    let url_ = getBaseUrl() + '/api/v1/user/files/{userId}/{fileId}/download';
    if (fileId === undefined || fileId === null)
        throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let download4DefaultOptions: Omit<
    UseQueryOptions<number[], unknown, number[]>,
    'queryKey' | 'queryFn'
> &
    Partial<Pick<UseQueryOptions<number[], unknown, number[]>, 'queryFn'>> = {};
export function getDownload4DefaultOptions() {
    return download4DefaultOptions;
}
export function setDownload4DefaultOptions(
    options: typeof download4DefaultOptions
) {
    download4DefaultOptions = options;
}

export function download4QueryKey(fileId: string): QueryKey;
export function download4QueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { fileId } = params[0] as Download4QueryParameters;

        return trimArrayEnd(['Client', 'download4', fileId as any]);
    } else {
        return trimArrayEnd(['Client', 'download4', ...params]);
    }
}
export function __download4(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.download4(context.queryKey[2] as string, axiosConfig);
}

export function useDownload4Query<TSelectData = number[], TError = unknown>(
    dto: Download4QueryParameters,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * DownloadFile
 * @param fileId FileID
 * @return OK
 */
export function useDownload4Query<TSelectData = number[], TError = unknown>(
    fileId: string,
    options?: Omit<UseQueryOptions<number[], TError, TSelectData>, 'queryKey'>,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useDownload4Query<TSelectData = number[], TError = unknown>(
    ...params: any[]
): UseQueryResult<TSelectData, TError> {
    let options: UseQueryOptions<number[], TError, TSelectData> | undefined =
        undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let fileId: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ fileId } = params[0] as Download4QueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [fileId, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<number[], TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __download4(context, axiosConfig)
            : __download4,
        queryKey: download4QueryKey(fileId),
        ...(download4DefaultOptions as unknown as Omit<
            UseQueryOptions<number[], TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * DownloadFile
 * @param fileId FileID
 * @return OK
 */
export function setDownload4Data(
    queryClient: QueryClient,
    updater: (data: number[] | undefined) => number[],
    fileId: string
) {
    queryClient.setQueryData(download4QueryKey(fileId), updater);
}

/**
 * DownloadFile
 * @param fileId FileID
 * @return OK
 */
export function setDownload4DataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: number[] | undefined) => number[]
) {
    queryClient.setQueryData(queryKey, updater);
}

export function forgetUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/forget';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function forgetMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'forget']);
}

/**
 * ForgetPassword
 * @param request Request
 * @return OK
 */
export function useForgetMutation<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Types.SignUpEmailRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Types.SignUpEmailRequest, TContext> {
    const key = forgetMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.SignUpEmailRequest) =>
            Client.forget(request),
        mutationKey: key,
    });
}

export function meGETUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/me';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let meGETDefaultOptions: Omit<
    UseQueryOptions<Types.GetMeResponse, unknown, Types.GetMeResponse>,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<Types.GetMeResponse, unknown, Types.GetMeResponse>,
            'queryFn'
        >
    > = {};
export function getMeGETDefaultOptions() {
    return meGETDefaultOptions;
}
export function setMeGETDefaultOptions(options: typeof meGETDefaultOptions) {
    meGETDefaultOptions = options;
}

export function meGETQueryKey(): QueryKey;
export function meGETQueryKey(...params: any[]): QueryKey {
    return trimArrayEnd(['Client', 'meGET']);
}
export function __meGET(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.meGET(axiosConfig);
}

/**
 * GetMe
 * @return OK
 */
export function useMeGETQuery<
    TSelectData = Types.GetMeResponse,
    TError = unknown
>(
    options?: Omit<
        UseQueryOptions<Types.GetMeResponse, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useMeGETQuery<
    TSelectData = Types.GetMeResponse,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.GetMeResponse, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;

    options = params[0] as any;
    axiosConfig = params[1] as any;

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.GetMeResponse, TError, TSelectData>({
        queryFn: axiosConfig
            ? (context) => __meGET(context, axiosConfig)
            : __meGET,
        queryKey: meGETQueryKey(),
        ...(meGETDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.GetMeResponse, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * GetMe
 * @return OK
 */
export function setMeGETData(
    queryClient: QueryClient,
    updater: (data: Types.GetMeResponse | undefined) => Types.GetMeResponse
) {
    queryClient.setQueryData(meGETQueryKey(), updater);
}

/**
 * GetMe
 * @return OK
 */
export function setMeGETDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: Types.GetMeResponse | undefined) => Types.GetMeResponse
) {
    queryClient.setQueryData(queryKey, updater);
}

export function mePOSTUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/me';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function mePOSTMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'mePOST']);
}

/**
 * UpdateMe
 * @param request Request
 * @return OK
 */
export function useMePOSTMutation<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, Types.UpdateMeRequest, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Types.UpdateMeRequest, TContext> {
    const key = mePOSTMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.UpdateMeRequest) => Client.mePOST(request),
        mutationKey: key,
    });
}

export function meDELETEUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/user/me';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function meDELETEMutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'meDELETE']);
}

/**
 * DeleteAccount
 * @return OK
 */
export function useMeDELETEMutation<TContext>(
    options?: Omit<
        UseMutationOptions<void, unknown, void, TContext>,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, void, TContext> {
    const key = meDELETEMutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: () => Client.meDELETE(),
        mutationKey: key,
    });
}

export function password2Url(): string {
    let url_ = getBaseUrl() + '/api/v1/user/password';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

export function password2MutationKey(): MutationKey {
    return trimArrayEnd(['Client', 'password2']);
}

/**
 * ChangePassword
 * @param request Request
 * @return OK
 */
export function usePassword2Mutation<TContext>(
    options?: Omit<
        UseMutationOptions<
            void,
            unknown,
            Types.ChangePasswordRequest,
            TContext
        >,
        'mutationKey' | 'mutationFn'
    >
): UseMutationResult<void, unknown, Types.ChangePasswordRequest, TContext> {
    const key = password2MutationKey();

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useMutation({
        ...options,
        mutationFn: (request: Types.ChangePasswordRequest) =>
            Client.password2(request),
        mutationKey: key,
    });
}

export function wsUrl(): string {
    let url_ = getBaseUrl() + '/api/v1/ws';
    url_ = url_.replace(/[?&]$/, '');
    return url_;
}

let wsDefaultOptions: Omit<
    UseQueryOptions<Types.ResponseMessage, unknown, Types.ResponseMessage>,
    'queryKey' | 'queryFn'
> &
    Partial<
        Pick<
            UseQueryOptions<
                Types.ResponseMessage,
                unknown,
                Types.ResponseMessage
            >,
            'queryFn'
        >
    > = {};
export function getWsDefaultOptions() {
    return wsDefaultOptions;
}
export function setWsDefaultOptions(options: typeof wsDefaultOptions) {
    wsDefaultOptions = options;
}

export function wsQueryKey(request: Types.RequestMessage): QueryKey;
export function wsQueryKey(...params: any[]): QueryKey {
    if (params.length === 1 && isParameterObject(params[0])) {
        const { request } = params[0] as WsQueryParameters;

        return trimArrayEnd(['Client', 'ws', request as any]);
    } else {
        return trimArrayEnd(['Client', 'ws', ...params]);
    }
}
export function __ws(
    context: QueryFunctionContext,
    axiosConfig?: AxiosRequestConfig | undefined
) {
    return Client.ws(context.queryKey[2] as Types.RequestMessage, axiosConfig);
}

export function useWsQuery<
    TSelectData = Types.ResponseMessage,
    TError = unknown
>(
    dto: WsQueryParameters,
    options?: Omit<
        UseQueryOptions<Types.ResponseMessage, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
/**
 * RegisterWS
 * @param request Request
 * @return OK
 */
export function useWsQuery<
    TSelectData = Types.ResponseMessage,
    TError = unknown
>(
    request: Types.RequestMessage,
    options?: Omit<
        UseQueryOptions<Types.ResponseMessage, TError, TSelectData>,
        'queryKey'
    >,
    axiosConfig?: Partial<AxiosRequestConfig>
): UseQueryResult<TSelectData, TError>;
export function useWsQuery<
    TSelectData = Types.ResponseMessage,
    TError = unknown
>(...params: any[]): UseQueryResult<TSelectData, TError> {
    let options:
        | UseQueryOptions<Types.ResponseMessage, TError, TSelectData>
        | undefined = undefined;
    let axiosConfig: AxiosRequestConfig | undefined = undefined;
    let request: any = undefined;

    if (params.length > 0) {
        if (isParameterObject(params[0])) {
            ({ request } = params[0] as WsQueryParameters);
            options = params[1];
            axiosConfig = params[2];
        } else {
            [request, options, axiosConfig] = params;
        }
    }

    const metaContext = useContext(QueryMetaContext);
    options = addMetaToOptions(options, metaContext);

    return useQuery<Types.ResponseMessage, TError, TSelectData>({
        queryFn: axiosConfig ? (context) => __ws(context, axiosConfig) : __ws,
        queryKey: wsQueryKey(request),
        ...(wsDefaultOptions as unknown as Omit<
            UseQueryOptions<Types.ResponseMessage, TError, TSelectData>,
            'queryKey'
        >),
        ...options,
    });
}
/**
 * RegisterWS
 * @param request Request
 * @return OK
 */
export function setWsData(
    queryClient: QueryClient,
    updater: (data: Types.ResponseMessage | undefined) => Types.ResponseMessage,
    request: Types.RequestMessage
) {
    queryClient.setQueryData(wsQueryKey(request), updater);
}

/**
 * RegisterWS
 * @param request Request
 * @return OK
 */
export function setWsDataByQueryId(
    queryClient: QueryClient,
    queryKey: QueryKey,
    updater: (data: Types.ResponseMessage | undefined) => Types.ResponseMessage
) {
    queryClient.setQueryData(queryKey, updater);
}
